(function () {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'LhQPEX';
  var KLAVIYO_REVISION = '2025-04-15';

  var modal = document.getElementById('liw-bis-modal');
  if (!modal) { return; }

  var emailInput = document.getElementById('liw-bis-email');
  var submitBtn = document.getElementById('liw-bis-submit');
  var closeBtn = document.getElementById('liw-bis-close');
  var formWrap = modal.querySelector('.liw-bis-form-wrap');
  var successWrap = document.getElementById('liw-bis-success');
  var submitDefaultText = submitBtn ? submitBtn.textContent : 'Notify Me';
  var prefillEmail = modal.getAttribute('data-bis-customer-email') || '';
  var activeVariantId = null;
  var lastFocused = null;

  function getKlaviyoCompanyId() {
    var script = document.querySelector('script[src*="klaviyo.com"][src*="company_id"]');
    if (script) {
      var m = script.src.match(/company_id=([^&]+)/);
      if (m) { return m[1]; }
    }
    var learnq = window._learnq || [];
    for (var i = 0; i < learnq.length; i++) {
      if (Array.isArray(learnq[i]) && learnq[i][0] === 'account') { return learnq[i][1]; }
    }
    return KLAVIYO_PUBLIC_KEY || null;
  }

  function isKlaviyoEnabled() {
    return !!(getKlaviyoCompanyId() || window.klaviyo || window._klOnsite);
  }

  function convertToSoldOut(btn) {
    btn.textContent = 'Sold Out';
    btn.disabled = true;
    btn.removeAttribute('data-bis-variant-id');
    btn.removeAttribute('data-bis-pdp-trigger');
  }

  function updateBisButtons() {
    if (isKlaviyoEnabled()) { return; }
    document.querySelectorAll('[data-bis-variant-id], [data-bis-pdp-trigger]').forEach(convertToSoldOut);
  }

  function syncBisButtons(form) {
    var notifyBtn = form.querySelector('[data-bis-pdp-trigger]');
    var atcBtn = form.querySelector('[data-product-atc]');
    return function (e) {
      var variant = e.detail.variant;
      var unavailable = !!variant && variant.available === false;
      if (notifyBtn) { notifyBtn.hidden = !unavailable; }
      if (atcBtn) { atcBtn.hidden = unavailable; }
    };
  }

  function wireVariantSelection(el) {
    if (el.__liwBisWired) { return; }
    var form = el.closest('form[data-product-form]');
    if (!form) { return; }
    el.__liwBisWired = true;
    el.addEventListener('variant-change', syncBisButtons(form));
  }

  function scanForVariantSelection(root) {
    if (!root.querySelectorAll) { return; }
    root.querySelectorAll('[data-variant-selection]').forEach(wireVariantSelection);
  }

  function observeVariantSelection() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) { return; }
          if (node.matches && node.matches('[data-variant-selection]')) { wireVariantSelection(node); }
          scanForVariantSelection(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function resolvePdpVariantId() {
    var fromUrl = new URL(window.location.href).searchParams.get('variant');
    if (fromUrl) { return fromUrl; }
    // [name="id"] instead of input[name="id"]: Empire renders the variant id
    // as a <select name="id"> on multi-variant products.
    var addForm = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (addForm && addForm.value) { return addForm.value; }
    var anyId = document.querySelector('[name="id"]');
    return anyId && anyId.value ? anyId.value : null;
  }

  function openModal(variantId) {
    if (!variantId) { return; }
    activeVariantId = variantId;
    if (emailInput) { emailInput.value = prefillEmail; }
    if (formWrap) { formWrap.hidden = false; }
    if (successWrap) { successWrap.hidden = true; }
    if (submitBtn) { submitBtn.textContent = submitDefaultText; submitBtn.disabled = false; }
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.classList.add('is-open');
    window.setTimeout(function () { if (emailInput) { emailInput.focus(); } }, 50);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.hidden = true;
    activeVariantId = null;
    if (lastFocused && typeof lastFocused.focus === 'function') { lastFocused.focus(); }
  }

  window.LIW = window.LIW || {};
  window.LIW.openBackInStock = openModal;

  if (closeBtn) { closeBtn.addEventListener('click', closeModal); }
  modal.addEventListener('click', function (e) { if (e.target === modal) { closeModal(); } });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) { closeModal(); }
  });

  function submit() {
    var email = emailInput ? emailInput.value.trim() : '';
    if (!email || !activeVariantId) { return; }

    var companyId = getKlaviyoCompanyId();
    if (!companyId) { submitBtn.textContent = 'Try again'; return; }

    submitBtn.textContent = 'Sending…';
    submitBtn.disabled = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + companyId + '&revamp=true', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + activeVariantId } }
          }
        }
      })
    })
      .then(function (res) {
        if (res.ok || res.status === 202 || res.status === 404) {
          if (formWrap) { formWrap.hidden = true; }
          if (successWrap) { successWrap.hidden = false; }
          window.setTimeout(closeModal, 3000);
        } else {
          return res.text().then(function (t) { throw new Error(t); });
        }
      })
      .catch(function () {
        submitBtn.textContent = 'Try again';
        submitBtn.disabled = false;
      });
  }

  if (submitBtn) { submitBtn.addEventListener('click', submit); }
  if (emailInput) {
    emailInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { submit(); } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bis-variant-id]');
    if (!btn) { return; }
    e.preventDefault();
    openModal(btn.getAttribute('data-bis-variant-id'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bis-pdp-trigger]');
    if (!btn) { return; }
    e.preventDefault();
    openModal(resolvePdpVariantId());
  });

  function openFromHash() {
    if (window.location.hash !== '#notify') { return; }
    openModal(resolvePdpVariantId());
  }

  function init() {
    updateBisButtons();
    scanForVariantSelection(document);
    observeVariantSelection();
    openFromHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
